'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Ratio = require('./Ratio');

var _Ratio2 = _interopRequireDefault(_Ratio);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _Ratio2.default;